import React, { PureComponent } from 'react'
import * as R from 'ramda'
import { parseHtmlForReact } from '../../helpers'
import '../../../assets/scss/switch.scss'

class Switch extends PureComponent {
    getSwitchValue = (value) => {
        const valueMap = {
            M2: 'M<sup>2</sup>',
            Ft2: 'Ft<sup>2</sup>',
        }
        return parseHtmlForReact(R.pathOr(value, [value], valueMap))
    }

    submitThreePartSwitch = (e, index) => {
        const { onChange, setCantAnswer } = this.props
        const { checked } = e.target

        if (checked && index === 3) {
            setCantAnswer(true)
        }

        if (checked && index !== 3) {
            onChange(e, index)
            setCantAnswer(false)
        }
    }

    getNonRequiredLabel = (nonRequiredText) => {
        const { question, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        let localeLabel = ''
        if (nonRequiredText[langcode]) {
            localeLabel = nonRequiredText[langcode]
        } else if (nonRequiredText[defaultLocale]) {
            localeLabel = nonRequiredText[defaultLocale]
        } else if (nonRequiredText[initialLocale]) {
            localeLabel = nonRequiredText[initialLocale]
        }

        return localeLabel
    }

    render() {
        const {
            left, right, onChange, value, nonRequiredOption, question, noLabel, nonRequiredText, formSwitch, store,
        } = this.props
        console.log(`switch ${left}, ${right}`)
        return (
            !nonRequiredOption ? (
                <div className="switch" style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                    {this.getSwitchValue(left)}
                    <label className="switch">
                        <input type="checkbox" defaultChecked={(value === right)} onChange={onChange}/>
                        <span className="slider" />
                    </label>
                    {this.getSwitchValue(right)}
                </div>
            ) : (
                <div
                    className=
                        {`threePointSwitch 
                            ${store.displayForMobile() ? 'mobile' : 'desktop '} 
                            ${noLabel ? 'noLabel' : ''} ${formSwitch ? 'formSwitch' : ''}`
                        }
                >
                    <div className="switchOption">
                        <label htmlFor={store.displayForMobile() && `${question.id}_1`} className='optionLabel'>
                            <div>{this.getSwitchValue(left)}</div>
                        </label>
                        <label className="radioInput">
                            <input id={`${question.id}_1`} type="radio" name={question.id} defaultChecked={(value === left)} onChange={e => this.submitThreePartSwitch(e, 0)} />
                            <span className="radioCustom" />
                        </label>
                    </div>
                    <div className="switchOption">
                        <label htmlFor={store.displayForMobile() && `${question.id}_2`} className='optionLabel'>
                            <div>{this.getSwitchValue(right)}</div>
                        </label>
                        <label className="radioInput">
                            <input id={`${question.id}_2`} type="radio" name={question.id} defaultChecked={(value === right)} onChange={e => this.submitThreePartSwitch(e, 1)} />
                            <span className="radioCustom" />
                        </label>
                    </div>
                    <div className="switchOption">
                        <label htmlFor={store.displayForMobile() && `${question.id}_3`} className='optionLabel'>
                            <div>{this.getNonRequiredLabel(nonRequiredText)}</div>
                        </label>
                        <label className="radioInput">
                            <input id={`${question.id}_3`} type="radio" name={question.id} defaultChecked={(question.cantAnswer === true)} onChange={e => this.submitThreePartSwitch(e, 3)} />
                            <span className="radioCustom" />
                        </label>
                    </div>
                </div>
            )
        )
    }
}

export default Switch
